export function chunkNumberArray(array: number[], chunkSize: number) {
  const chunks: number[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }

  return chunks;
}

export const isDefined = <T>(input: T | undefined | null): input is T =>
  typeof input !== 'undefined' && input !== null;

export const isTruthy = <T>(input: T | undefined | null): input is T =>
  Boolean(input);
